export default __webpack_public_path__ + "static/shutdown-banner-mobile-b9d6ebd7a171c0489a43a38a1d272cf5.png";